module.exports = __webpack_public_path__ + "static/scale-model-of-venus-de-milo-statue-in-san-francisco-california-186edd12fff6ddbfd2314f1b1b420a35.png";